module.exports = "<div class=\"container\">\n  <router-outlet></router-outlet>\n</div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// /Users/ericzayas/Documents/relativePitch/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main